<template>
<div class="cc-user-kombox-form">
  <form :id="_uid" @focusout="isFormBlur"  @keyup.esc="$emit('cancel', kombox)" @submit.prevent="onExit" >
    <div class="row" >
      <div class="col-sm-2 text-right" style="padding-right: 0px">
       <select class="form-control text-right" v-model="editKombox.type">
          <option v-for="option in options" v-bind:value="option.value">
          {{ option.text }}
          </option>
        </select>
      </div>
      <div class="col-sm-5" style="padding: 0px">
        <input v-focus required
          class="form-control"
          type="text"
          :pattern="KomboxConf.TYPES[editKombox.type].CONTENT.PATTERN"
          :placeholder="KomboxConf.TYPES[editKombox.type].CONTENT.PLACEHOLDER"
          :title="KomboxConf.TYPES[editKombox.type].CONTENT.PLACEHOLDER"
          v-model="editKombox.content" >
      </div>
      <div class="col-sm-4" style="padding-left: 0px">
        <input type="text" class="form-control" placeholder="privat, office ..." v-model="editKombox.description">
      </div>
      <div class="col-sm-1 text-right" style="padding: 0px">
        <button v-if="editKombox.content" 
           type="submit"
           :form="_uid" 
           class="btn btn-sm btn-primary">
           <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
        <button v-else
           type="submit"
          :form="_uid" 
          class="btn btn-sm" 
          @click="onClickTrash">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </form> 
</div> 
</template>



<script>

//import bus from './common/bus'
import KomboxCommon from './common/kombox.common'

export default {
  
  extends: KomboxCommon,
  
  data () {
    return {
      editKombox: JSON.parse(JSON.stringify(this.kombox)), 
      options: [
        { text: 'Telefon', value: '0' },
        { text: 'Mobile', value: '1' },
        { text: 'Email', value: '2' },
        { text: 'Fax', value: '3' },
        { text: 'Web', value: '4' }
      ]
      
    }
  },
  
    
    
  
  mounted: function () {
    //setTimeout(this.isFormBlur, 1500);
    
  },
  
  computed: {

    
  },
  
  methods: {
    

    isFormBlur: _.debounce( function () {

        if($('#'+this._uid).find('*:focus').size() == 0){
          //$('#'+this._uid)[0].checkValidity())
          //$('#'+this._uid).find(':submit').click();
        }
      
    },150),
    
    onExit: function () {
      if(_.isEqual(this.kombox, this.editKombox)){
        // keine Änderung, speichern nicht notwendig
        this.$emit('cancel', this.kombox)
      }else{
        // speichern
        this.$emit('save', this.editKombox)
      }
    },
    
    onClickTrash: function () {
      if(this.kombox.id > 0 ){
         this.$emit('remove', this.kombox);
      }else{
        this.$emit('cancel', this.kombox);
      }
    },

  },
}
  
</script>



<style scoped>

  .row{
    margin: 0;
  }
  
input:invalid {
  border: 1px solid red;
}
  
.cc-user-kombox-form{
    border-left: 5px solid #f9f7c0;
}
  
</style>



// WEBPACK FOOTER //
// KomboxForm.vue?c4168b4a